(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3268,4012,5467],{

/***/ 73:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _id_; }
});

// EXTERNAL MODULE: ./src/components/Shared/BreadCrumbs.js
var BreadCrumbs = __webpack_require__(5467);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(6896);
// EXTERNAL MODULE: ./styles/projects.module.scss
var projects_module = __webpack_require__(6154);
var projects_module_default = /*#__PURE__*/__webpack_require__.n(projects_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/Home/Blogs/SingleBlog/styles/style.module.scss
var style_module = __webpack_require__(0);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/handlers/index.js + 1 modules
var handlers = __webpack_require__(9400);
// EXTERNAL MODULE: ./src/utils/whatsapp.mjs
var whatsapp = __webpack_require__(735);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/Home/Blogs/SingleBlog/index.js












var SingleBlog = function SingleBlog(_ref) {
  var _singleBlog$title, _singleBlog$title2, _blogCategory$title, _blogCategory$title2, _singleBlog$descripti;

  var singleBlog = _ref.singleBlog,
      blogCategory = _ref.blogCategory,
      siteInfo = _ref.siteInfo;

  var _useRouter = (0,router.useRouter)(),
      locale = _useRouter.locale;

  var formatDate = function formatDate(dateString, locale) {
    return new Intl.DateTimeFormat(locale === "ar" ? "ar-EG-u-nu-latn" : "en-GB-u-nu-latn", {
      day: "numeric",
      month: "long",
      year: "numeric"
    }).format(new Date(dateString));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "".concat((style_module_default())["single-blog"]),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
      className: "mt-5",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "blog-container",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "blog-wrapper",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "blog-image",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: (0,handlers/* handleImage */.M)(singleBlog === null || singleBlog === void 0 ? void 0 : singleBlog.image),
              width: 600,
              height: 400,
              unoptimized: true,
              alt: singleBlog === null || singleBlog === void 0 ? void 0 : (_singleBlog$title = singleBlog.title) === null || _singleBlog$title === void 0 ? void 0 : _singleBlog$title[locale],
              priority: true
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "blog-title",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              children: singleBlog === null || singleBlog === void 0 ? void 0 : (_singleBlog$title2 = singleBlog.title) === null || _singleBlog$title2 === void 0 ? void 0 : _singleBlog$title2[locale]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "blog-info",
            children: [blogCategory && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "blog-category",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("h4", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("b", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "category"
                  }), ":", " "]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: "/blogs/category/".concat(blogCategory === null || blogCategory === void 0 ? void 0 : blogCategory.id),
                  "aria-label": "Link to category ".concat((blogCategory === null || blogCategory === void 0 ? void 0 : (_blogCategory$title = blogCategory.title) === null || _blogCategory$title === void 0 ? void 0 : _blogCategory$title[locale]) || ""),
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    children: blogCategory === null || blogCategory === void 0 ? void 0 : (_blogCategory$title2 = blogCategory.title) === null || _blogCategory$title2 === void 0 ? void 0 : _blogCategory$title2[locale]
                  })
                })]
              })
            }), (singleBlog === null || singleBlog === void 0 ? void 0 : singleBlog.createdAt) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "blog-category date",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("h4", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("b", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "PublishDate"
                  }), ":", " "]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  locale: locale,
                  children: formatDate(singleBlog === null || singleBlog === void 0 ? void 0 : singleBlog.createdAt, locale)
                })]
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "blog-description",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              dangerouslySetInnerHTML: {
                __html: singleBlog === null || singleBlog === void 0 ? void 0 : (_singleBlog$descripti = singleBlog.description) === null || _singleBlog$descripti === void 0 ? void 0 : _singleBlog$descripti[locale]
              }
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "blog-btns",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: (0,whatsapp/* buildWhatsAppUrl */.H)(siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo.whatsup),
              target: "_blank",
              className: "whatsapp rounded-5",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "freeConsultation"
              })
            })
          })]
        })
      })
    })
  });
};

/* harmony default export */ var Blogs_SingleBlog = (SingleBlog);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/components/helpers/seo.js
var helpers_seo = __webpack_require__(540);
;// CONCATENATED MODULE: ./pages/blogs/[id].js











var SingleBlogPage = function SingleBlogPage(_ref) {
  var _singleBlog$data, _singleBlog$data$blog, _singleBlog$title, _seo$title, _singleBlog$descripti, _seo$description, _singleBlog$data2, _singleBlog$data2$blo, _singleBlog$data2$blo2, _singleBlog$data3, _singleBlog$data3$blo, _singleBlog$data3$blo2, _singleBlog$data3$blo3, _singleBlog$data4, _singleBlog$data4$blo, _singleBlog$data4$blo2, _singleBlog$data4$blo3, _singleBlog$data5;

  var singleBlog = _ref.singleBlog,
      siteInfo = _ref.siteInfo;

  var _useIntl = (0,useIntl/* default */.Z)(),
      locale = _useIntl.locale,
      formatMessage = _useIntl.formatMessage;

  var seo = singleBlog === null || singleBlog === void 0 ? void 0 : (_singleBlog$data = singleBlog.data) === null || _singleBlog$data === void 0 ? void 0 : (_singleBlog$data$blog = _singleBlog$data.blogObj) === null || _singleBlog$data$blog === void 0 ? void 0 : _singleBlog$data$blog.seo;

  var _useRouter = (0,router.useRouter)(),
      asPath = _useRouter.asPath;

  var _buildSeoAlternates = (0,helpers_seo/* buildSeoAlternates */.Rl)(asPath, locale),
      canonical = _buildSeoAlternates.canonical,
      languageAlternates = _buildSeoAlternates.languageAlternates;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: (singleBlog === null || singleBlog === void 0 ? void 0 : (_singleBlog$title = singleBlog.title) === null || _singleBlog$title === void 0 ? void 0 : _singleBlog$title[locale]) || (seo === null || seo === void 0 ? void 0 : (_seo$title = seo.title) === null || _seo$title === void 0 ? void 0 : _seo$title[locale]),
      description: (singleBlog === null || singleBlog === void 0 ? void 0 : (_singleBlog$descripti = singleBlog.description) === null || _singleBlog$descripti === void 0 ? void 0 : _singleBlog$descripti[locale]) || (seo === null || seo === void 0 ? void 0 : (_seo$description = seo.description) === null || _seo$description === void 0 ? void 0 : _seo$description[locale]),
      canonical: canonical,
      languageAlternates: languageAlternates
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (projects_module_default()).projectsPage,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BreadCrumbs["default"], {
        heading: singleBlog === null || singleBlog === void 0 ? void 0 : (_singleBlog$data2 = singleBlog.data) === null || _singleBlog$data2 === void 0 ? void 0 : (_singleBlog$data2$blo = _singleBlog$data2.blogObj) === null || _singleBlog$data2$blo === void 0 ? void 0 : (_singleBlog$data2$blo2 = _singleBlog$data2$blo.title) === null || _singleBlog$data2$blo2 === void 0 ? void 0 : _singleBlog$data2$blo2[locale],
        description: "".concat(formatMessage({
          id: "main"
        }), " / ").concat(formatMessage({
          id: "blogs"
        }), " / ").concat(singleBlog === null || singleBlog === void 0 ? void 0 : (_singleBlog$data3 = singleBlog.data) === null || _singleBlog$data3 === void 0 ? void 0 : (_singleBlog$data3$blo = _singleBlog$data3.blogObj) === null || _singleBlog$data3$blo === void 0 ? void 0 : (_singleBlog$data3$blo2 = _singleBlog$data3$blo.title) === null || _singleBlog$data3$blo2 === void 0 ? void 0 : (_singleBlog$data3$blo3 = _singleBlog$data3$blo2[locale]) === null || _singleBlog$data3$blo3 === void 0 ? void 0 : _singleBlog$data3$blo3.slice(0, 50)).concat((singleBlog === null || singleBlog === void 0 ? void 0 : (_singleBlog$data4 = singleBlog.data) === null || _singleBlog$data4 === void 0 ? void 0 : (_singleBlog$data4$blo = _singleBlog$data4.blogObj) === null || _singleBlog$data4$blo === void 0 ? void 0 : (_singleBlog$data4$blo2 = _singleBlog$data4$blo.title) === null || _singleBlog$data4$blo2 === void 0 ? void 0 : (_singleBlog$data4$blo3 = _singleBlog$data4$blo2[locale]) === null || _singleBlog$data4$blo3 === void 0 ? void 0 : _singleBlog$data4$blo3.length) > 50 && "..."),
        background: singleBlog === null || singleBlog === void 0 ? void 0 : singleBlog.breadCrumbImage
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "wrapper",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "projects-body category-id",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Blogs_SingleBlog, {
            blogCategory: singleBlog === null || singleBlog === void 0 ? void 0 : singleBlog.blogCategory,
            singleBlog: singleBlog === null || singleBlog === void 0 ? void 0 : (_singleBlog$data5 = singleBlog.data) === null || _singleBlog$data5 === void 0 ? void 0 : _singleBlog$data5.blogObj,
            siteInfo: siteInfo
          })
        })
      })]
    })]
  });
};

var __N_SSP = true;
/* harmony default export */ var _id_ = (SingleBlogPage);

/***/ }),

/***/ 5467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(682);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6896);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);







var BreadCrumb = function BreadCrumb(_ref) {
  var _heading$locale, _description$locale;

  var heading = _ref.heading,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? "" : _ref$description;

  var _useIntl = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(),
      locale = _useIntl.locale;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)(),
      pathname = _useRouter.pathname;

  var shouldHidePath = pathname.startsWith("/blogs/") && pathname !== "/blogs";
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    className: "breads wrapper",
    style: {
      backgroundColor: "rgb(112 96 166 / 100%)"
    },
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "inner",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h1", {
          className: "unique-bold h3",
          children: (_heading$locale = heading === null || heading === void 0 ? void 0 : heading[locale]) !== null && _heading$locale !== void 0 ? _heading$locale : heading
        }), ((description === null || description === void 0 ? void 0 : description[locale]) || (description === null || description === void 0 ? void 0 : description.length) > 0) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ul", {
          children: !shouldHidePath && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
            children: (_description$locale = description === null || description === void 0 ? void 0 : description[locale]) !== null && _description$locale !== void 0 ? _description$locale : description
          })
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (BreadCrumb);

/***/ }),

/***/ 9400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ handleImage; }
});

;// CONCATENATED MODULE: ./src/assets/images/placeholder.jpg
/* harmony default export */ var placeholder = ({"src":"/_next/static/media/placeholder.75cf2fc2.jpg","height":319,"width":474,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAUACAMBIgACEQEDEQH/xAAnAAEBAAAAAAAAAAAAAAAAAAAABwEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAAAsgP/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/9oACAEBAAE/AH//xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oACAECAQE/AH//xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oACAEDAQE/AH//2Q==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/components/handlers/index.js

var handleImage = function handleImage(image) {
  var _ref;

  if ((_ref = "".concat(image)) !== null && _ref !== void 0 && _ref.includes("http")) return image;

  if (image) {
    if (!image.startsWith("/")) image = "/".concat(image);
    return "".concat("https://alnojoom.ejjadh.info/").concat(image);
  }

  return image || (placeholder === null || placeholder === void 0 ? void 0 : placeholder.src);
};

/***/ }),

/***/ 540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rl": function() { return /* binding */ buildSeoAlternates; }
/* harmony export */ });
/* unused harmony exports SITE_URL, DEFAULT_LOCALE, localizedUrl */
// ====== إعدادات الـ SEO المشتركة ======
var SITE_URL = "https://alnjoom.sa";
var DEFAULT_LOCALE = "ar"; // النسخة الافتراضية (x-default) هي العربية
// ينظّف الـ path: يشيل الـ query/hash ويضبط الـ trailing slash

var normalizePath = function normalizePath() {
  var asPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var path = String(asPath).split("?")[0].split("#")[0] || "/";
  if (!path.startsWith("/")) path = "/".concat(path); // مطابقة لإعداد trailingSlash: true في next.config.js

  if (path !== "/" && !path.endsWith("/")) path = "".concat(path, "/");
  return path;
}; // يبني رابط مطلق للّغة المطلوبة (العربية بدون بادئة، الإنجليزية ببادئة /en)


var localizedUrl = function localizedUrl(asPath, locale) {
  var path = normalizePath(asPath); // يبدأ بـ "/" وينتهي بـ "/"

  if (locale === DEFAULT_LOCALE) return "".concat(SITE_URL).concat(path);
  return path === "/" ? "".concat(SITE_URL, "/").concat(locale, "/") : "".concat(SITE_URL, "/").concat(locale).concat(path);
}; // يبني canonical + hreflang (ar / en / x-default) لأي صفحة
// x-default يشير دائمًا للنسخة العربية

var buildSeoAlternates = function buildSeoAlternates(asPath) {
  var currentLocale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_LOCALE;
  return {
    canonical: localizedUrl(asPath, currentLocale),
    languageAlternates: [{
      hrefLang: "ar",
      href: localizedUrl(asPath, "ar")
    }, {
      hrefLang: "en",
      href: localizedUrl(asPath, "en")
    }, {
      hrefLang: "x-default",
      href: localizedUrl(asPath, DEFAULT_LOCALE)
    }]
  };
};

/***/ }),

/***/ 5993:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/[id]",
      function () {
        return __webpack_require__(73);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 0:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"single-blog":"style_single-blog__3EV7h"};

/***/ }),

/***/ 6154:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"singleProjectBody":"projects_singleProjectBody__uWgzA","projectsPage":"projects_projectsPage__KcKLX","gradient_in":"projects_gradient_in__qfyMX","gradient_out":"projects_gradient_out___jDot","gradient_opacity_out":"projects_gradient_opacity_out__ZfHDe","gradient_opacity_in":"projects_gradient_opacity_in__cs9x8"};

/***/ }),

/***/ 682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);
"use client";





const Container = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  fluid = false,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  className,
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'container');
  const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, fluid ? `${prefix}${suffix}` : prefix)
  });
});
Container.displayName = 'Container';
/* harmony default export */ __webpack_exports__["Z"] = (Container);

/***/ }),

/***/ 4012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(680);
/* harmony import */ var _useIntl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6896);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */




function areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(prevProps, ["values"]);
    var nextValues = nextProps.values, nextOtherProps = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(nextProps, ["values"]);
    return ((0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .shallowEqual */ .wU)(nextValues, values) &&
        (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .shallowEqual */ .wU)(otherProps, nextOtherProps));
}
function FormattedMessage(props) {
    var intl = (0,_useIntl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? react__WEBPACK_IMPORTED_MODULE_0__.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag,
    });
    if (typeof children === 'function') {
        return children(Array.isArray(nodes) ? nodes : [nodes]);
    }
    if (Component) {
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(nodes));
    }
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, nodes);
}
FormattedMessage.displayName = 'FormattedMessage';
var MemoizedFormattedMessage = react__WEBPACK_IMPORTED_MODULE_0__.memo(FormattedMessage, areEqual);
MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
/* harmony default export */ __webpack_exports__["Z"] = (MemoizedFormattedMessage);


/***/ }),

/***/ 735:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ buildWhatsAppUrl; }
/* harmony export */ });
/* unused harmony export WHATSAPP_MESSAGE */
var WHATSAPP_MESSAGE = "السلام عليكم ورحمة الله و بركاتة، وصلت إليكم من خلال موقع النجوم المميزة للاستقدام، وأرغب في الاستفسار عن خدمات الاستقدام والعروض المتاحة.";
var buildWhatsAppUrl = function buildWhatsAppUrl(phone) {
  return "https://wa.me/".concat(phone !== null && phone !== void 0 ? phone : "", "?text=").concat(encodeURIComponent(WHATSAPP_MESSAGE));
};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2962,2143,1664,9774,2888,179], function() { return __webpack_exec__(5993); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);